export const SET_SELECTED_ARTICLE = 'setSelectedArticle';
export const SET_ARTICLES = 'setArticles';
export const SET_RELATED_ARTICLES = 'setRelatedArticles';
export const SET_ARTICLES_BY_CATEGORY_LOADED = 'setArticlesByCategoryLoaded';
export const SET_NAV_COLLAPSE = 'setNavCollapse';
